import Deferred from "utils/Deferred";

/**
 * Promise always fired when Ad Sequencing is ready for action.
 * @returns {Promise} of ready event data
 */
const adSequencingReady = new Deferred();
export default adSequencingReady;
